import {   
REQUEST_GETREPAYMENTSBYCUSTOMERID,
RECEIVE_GETREPAYMENTSBYCUSTOMERID_SUCCESS,
RECEIVE_GETREPAYMENTSBYCUSTOMERID_ERROR

        }  from '../actions/application'




const DEFAULT_REPAYMENTS =   {
    isFetching: true,
    repayments: []
    };



export function repayments(state = DEFAULT_REPAYMENTS, action) {
        switch (action.type) {
        case REQUEST_GETREPAYMENTSBYCUSTOMERID: {
            var newstate = {
                repayments: [...state.repayments],             
                isFetching: true
            };
            return newstate;
        }
        case RECEIVE_GETREPAYMENTSBYCUSTOMERID_SUCCESS: {
           
            var newstate = {
                ...state,   
                repayments: action.repayments,
                isFetching: false
                 }

            return newstate;            
        }

        
        default: {
            return state;
        }
    }
}
